export const fr = {
  formFields: {
    locationCityNeighborhood: "Adresse de l'organisme ou point de rencontre",
    yourCityOfResidence: 'Votre ville de résidence',
    maxLocationsError:
      "Vous ne pouvez entrer qu'un maximum de {{limit}} emplacements.",
    dateSingleSelectField: {
      isPast:
        "Vous avez sélectionné une date dans le passé. Cet événement n'apparaîtra que dans les événements passés",
    },
  },
}
